import React, { useState, useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Line,
  Bar,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from "react-chartjs-2";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { Card, CardHeader, CardBody } from "../../../components/card/card";
import { useNavigate } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ changedValue, allData, rawDatas }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [allList, setAllList] = useState([]);
  const chartRef = useRef();
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Year",
        },
        ticks: {
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Quantity",
        },
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
      },
    },
  };
  const generateRandomArray = (length, min, max) => {
    const arr = [];
    for (let i = 0; i < length; i++) {
      arr.push(Math.floor(Math.random() * (max - min + 1)) + min);
    }
    return arr;
  };
  const [data, setData] = useState({
    labels: [
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
      "2033",
      "2034",
      "2035",
    ],
    datasets: [
      {
        label: "# of Asset",
        data: generateRandomArray(11, 0, 12),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(75, 192, 192, 0.9)",
      },
    ],
  });
  useEffect(() => {
    const labels = [];
    const data = [];
    const tmp = [];
    Object.keys(rawDatas).map((i) => {
      labels.push(i);
      data.push(rawDatas[i].length);
      tmp.push(rawDatas[i]);
    });
    setAllList(tmp);
    if (changedValue > 0) {
      setData({
        labels: labels,
        datasets: [
          {
            label: "# of Asset",
            data: data,
            borderColor: themeColor,
            backgroundColor: colors[changedValue % colors.length],
          },
        ],
      });
    }
  }, [rawDatas]);
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];
  const onClick = (event) => {
    const array = getElementsAtEvent(chartRef.current, event);
    const index = array[0].index;
    setSelected(allList[index]);
    setOpen(true);
  };

  return data ? (
    <div style={{ position: "relative", height: "473px", width: "100%" }}>
      <ConfirmationDlg
        open={open}
        size="xl"
        setOpen={setOpen}
        title="Asset List"
        data={selected}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
        onClose={() => setOpen(false)}
        onConfirm={() => setOpen(false)}
      >
        <Card className="border-theme">
          <CardBody>
            <div
              style={{
                height: "calc(100vh - 300px)",
                overflow: "auto",
              }}
            >
              <table className={"table table-bordered"}>
                <thead>
                  <tr>
                    <th>No</th>
                    <th style={{ minWidth: "195px" }}>Asset ID</th>
                    <th>Asset Name</th>
                    <th style={{ width: "300px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selected.map((i, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ minWidth: "195px" }}>
                          {i.machineStrategies?.machine?.id}
                        </td>
                        <td>{i.machineStrategies?.machine?.machine_name}</td>
                        <td style={{ width: "300px" }}>
                          <button
                            onClick={() => {
                              navigate(
                                "/machine-asset/investment-detail/" +
                                  i.machineStrategies?.machine?.id
                              );
                            }}
                            className="btn btn-sm btn-outline-theme mx-1"
                          >
                            <i className="fa fa-chart-bar"></i> Investment
                            Profile
                          </button>
                          <button
                            onClick={() => {
                              navigate(
                                "/machine-asset/rul-detail/" +
                                  i.machineStrategies?.machine?.id
                              );
                            }}
                            className="btn btn-sm btn-outline-theme mx-1"
                          >
                            <i className="fa fa-chart-pie"></i> RUL Simulation
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </ConfirmationDlg>
      <Bar ref={chartRef} options={options} data={data} onClick={onClick} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}

export default App;
